const initialState = () => {
    return {
        availableOptions: [],
        selectedOptions: []
    }
};

const state = initialState();

const mutations = {
    SET_AVAILABLE_OPTIONS(state, payload) {
        state.availableOptions = payload;
    },
    SET_SELECTED_OPTIONS(state, payload) {
        state.selectedOptions = state.selectedOptions.filter(o => o.product_id !== payload.product_id);
        state.selectedOptions.push(payload);
    }
};

const actions = {
    getAvailableOptions({state, commit}, payload) {
        commit('SET_AVAILABLE_OPTIONS', payload);
    },
    updateSelectedOption({state, commit}, payload) {
        if (Object.prototype.hasOwnProperty.call(payload, 'type')) {
            if (payload['type'] === 'radio') {
                const sameOptionGroupSelected = state.selectedOptions.findIndex(s => s['option_id'] === payload['option_id']);
                if (sameOptionGroupSelected >= 0) {
                    state.selectedOptions.splice(sameOptionGroupSelected, 1);
                }
            }
        }
        commit('SET_SELECTED_OPTIONS', payload);
    }
};

const getters = {
    availableOptions: state => {
        return state.availableOptions;
    },
    requiredOptions: (state, getters) => {
        return getters.availableOptions.filter(o => {
            return o.required === 1;
        });
    },
    totalPrices: state => {
        let prices = {
            priceInclTax: 0,
            priceExclTax: 0,
            totalPriceInclTax: 0,
            totalPriceExclTax: 0
        };
        state.selectedOptions.forEach(o => {
            prices.priceInclTax += (o.price * o.qty);
            prices.priceExclTax += (o.price * o.qty);
            prices.totalPriceInclTax += (o.price * o.qty);
            prices.totalPriceExclTax += (o.price * o.qty);
        });
        return prices;
    },
    isSaleable: (state, getters) => {
        let selectedRequiredOptions = [];
        getters.requiredOptions.forEach(o => {
            selectedRequiredOptions.push(state.selectedOptions.filter(r => {
                return r.option_id === o.option_id && r.qty > 0;
            }).length > 0);
        });
        return selectedRequiredOptions.every(Boolean);
    }
};

const CatalogBundleProduct = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

export default CatalogBundleProduct;
